import { Link } from "react-router-dom";
import Button from "../components/ui/Button";
import { ShieldCheck, Leaf, Users } from "lucide-react";

export default function Landing(){
  return(
    <>
    <nav className="bg-white border-b border-zinc-200 sticky top-0 z-50 shadow-sm">
        <div className="max-w-7xl mx-auto px-6 py-5 flex justify-between items-center">            
            <div className="flex items-center gap-x-3">
                <div id="logo-placeholder" className="w-10 h-10 bg-gradient-to-br from-emerald-600 to-blue-700 rounded-2xl flex items-center justify-center text-white font-bold text-2xl cursor-pointer">
                  <img src="/heritage.jpg" width="55" height="40" style={{borderRadius:"7px"}} alt="logo" ></img>
                </div>
                <div>
                    <span className="text-xl md:text-2xl font-bold tracking-tight heading-font text-emerald-700">
                        Heritage-
                    </span>
                    <span className="text-xl md:text-2xl font-semibold tracking-tight text-zinc-800">
                        Cooperative
                    </span>
                </div>
            </div>

            <div className="hidden md:flex items-center gap-x-8 text-sm font-medium">
                <a href="#home" className="nav-link text-zinc-700 hover:text-emerald-600">Home</a>
                <a href="#about" className="nav-link text-zinc-700 hover:text-emerald-600">About Us</a>
                <a href="#products" className="nav-link text-zinc-700 hover:text-emerald-600">Products</a>
                <a href="#careers" className="nav-link text-zinc-700 hover:text-emerald-600">Careers</a>
                <a href="#contact" className="nav-link text-zinc-700 hover:text-emerald-600">Contact</a>
            </div>

            <div className="flex items-center gap-x-4">
                <Link to="/login" 
                   className="px-5 py-2.5 text-sm font-semibold text-zinc-700 hover:text-zinc-900 border border-zinc-300 rounded-2xl hover:border-zinc-400 transition">
                    Sign In
                </Link>
                <Link to="/signup"
                   className="px-6 py-2.5 bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-semibold rounded-2xl transition shadow-lg shadow-emerald-200">
                    Join Now
                </Link>
                
                <button id="mobile-menu-btn" className="md:hidden text-2xl text-zinc-700">
                    <i className="fa-solid fa-bars"></i>
                </button>
            </div>
        </div>

        
        <div id="mobile-menu" className="hidden md:hidden bg-white border-t">
            <div className="px-6 py-8 flex flex-col gap-y-6 text-lg">
                <a href="#home" className="nav-link">Home</a>
                <a href="#about" className="nav-link">About Us</a>
                <a href="#products" className="nav-link">Products</a>
                <a href="#careers" className="nav-link">Careers</a>
                <a href="#contact" className="nav-link">Contact Us</a>
                <div className="pt-6 border-t flex flex-col gap-4">
                    <Link to="/signin" className="text-center py-3 border border-zinc-300 rounded-2xl">Sign In</Link>
                    <Link to="/signup" className="text-center py-3 bg-emerald-600 text-white rounded-2xl">Join the Cooperative</Link>
                </div>
            </div>
        </div>
    </nav>

    
    <section id="home" className="hero-bg h-screen flex items-center text-white">
        <div className="max-w-5xl mx-auto px-6 text-center">
            <div className="max-w-3xl mx-auto">
                <p className="inline-flex items-center gap-x-2 bg-white/20 backdrop-blur-md px-5 py-2 rounded-3xl text-sm mb-6">
                    <span className="w-2 h-2 bg-emerald-400 rounded-full animate-pulse"></span>
                    Your Trusted Financial Partner
                </p>
                <h1 className="text-6xl md:text-7xl font-bold heading-font leading-tight mb-6">
                    Grow Your Future<br />with <span className="text-emerald-400">Heritage</span>
                </h1>
                <p className="text-xl md:text-2xl text-white/90 max-w-xl mx-auto mb-10">
                    Secure savings, flexible loans, and community-driven financial growth.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <a href="#products" 
                       className="px-10 py-4 bg-white text-emerald-700 hover:bg-emerald-50 font-semibold text-lg rounded-3xl transition flex items-center justify-center gap-x-3">
                        Explore Products
                        <i className="fa-solid fa-arrow-right"></i>
                    </a>
                    <Link to="/signup" 
                       className="px-10 py-4 border-2 border-white hover:bg-white/10 font-semibold text-lg rounded-3xl transition">
                        Join Heritage Today
                    </Link>
                </div>
            </div>
        </div>
        <div className="absolute bottom-10 left-1/2 animate-bounce">
            <a href="#about"><i className="fa-solid fa-chevron-down text-3xl"></i></a>
        </div>
    </section>

    
    <section id="about" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-16 items-center">
                <div>
                    <div className="inline-flex items-center gap-2 text-emerald-600 font-medium mb-4">
                        <div className="h-px w-12 bg-emerald-600"></div>
                        OUR STORY
                    </div>
                    <h2 className="text-5xl heading-font font-bold leading-tight mb-8">Building prosperity together.</h2>
                    <div className="prose prose-lg text-zinc-600">
                        <p>Heritage Savings & Loans Cooperative Society Ltd. is a member-owned financial cooperative registered under CAP: No. 98 of the Nigerian Cooperative Societies 
                            Act/2004 with approval No. FCTA/ARDS/COOP/2019/11529. 
                            It is established to promote savings, provide affordable credit facilities, and improve the economic well-being of its members through cooperative principles. The Society mobilizes member’s 
                            savings, grants low-interest loans for personal, educational, agricultural, and business purposes, and encourages financial discipline, wealth creation, and investment.</p>
                        <p>Operating on the principles of mutual trust, transparency, and democratic governance, Heritage Savings & Loans Cooperative Society Ltd. is committed to empowering its members by providing accessible 
                            financial services, financial education, and opportunities for sustainable economic growth. The Society also aims to foster a culture of self-reliance, social responsibility, and shared prosperity 
                            while leveraging modern technology to deliver efficient, secure, and member-focused cooperative services.</p>
                        
                    </div>
                    <div className="mt-12 grid grid-cols-3 gap-8">
                        {/* <div>
                            <div className="text-4xl font-bold text-emerald-600">15k+</div>
                            <div className="text-sm text-zinc-500">Active Members</div>
                        </div>
                        <div>
                            <div className="text-4xl font-bold text-emerald-600">180M</div>
                            <div className="text-sm text-zinc-500">Assets Under Management</div>
                        </div>
                        <div>
                            <div className="text-4xl font-bold text-emerald-600">98%</div>
                            <div className="text-sm text-zinc-500">Member Satisfaction</div>
                        </div> */}
                    </div>
                </div>
                <div className="relative">
                    <img src="https://picsum.photos/id/201/800/600" alt="Heritage Cooperative Team" 
                         className="rounded-3xl shadow-2xl" />
                    <div className="absolute -bottom-6 -right-6 bg-white p-6 rounded-3xl shadow-xl max-w-[220px]">
                        <div className="flex items-center gap-x-4">
                            <div className="text-emerald-500 text-4xl">★</div>
                            <div>
                                <div className="font-semibold">Rated top Cooperative</div>
                                <div className="text-sm text-zinc-500">by our members</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    
    <section id="products" className="py-24 bg-zinc-900 text-white">
        <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
                <div className="inline-flex items-center gap-2 text-emerald-400 font-medium mb-4">
                    <div className="h-px w-12 bg-emerald-400"></div>
                    OUR OFFERINGS
                </div>
                <h2 className="text-5xl heading-font font-bold">Financial Products for Every Stage of Life</h2>
            </div>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                
                <div className="bg-zinc-800 rounded-3xl p-8 card-hover">
                    <div className="h-14 w-14 bg-emerald-500/10 rounded-2xl flex items-center justify-center mb-8">
                        <i className="fa-solid fa-piggy-bank text-3xl text-emerald-400"></i>
                    </div>
                    <h3 className="text-3xl font-semibold mb-3">Savings Accounts</h3>
                    <p className="text-zinc-400 mb-8">High-yield savings with competitive rates and easy access to your funds.</p>
                    <ul className="space-y-3 text-sm">
                        <li className="flex items-center gap-x-3"><i className="fa-solid fa-check text-emerald-400"></i> Up to 5.5% APY</li>
                        <li className="flex items-center gap-x-3"><i className="fa-solid fa-check text-emerald-400"></i> No monthly fees</li>
                        <li className="flex items-center gap-x-3"><i className="fa-solid fa-check text-emerald-400"></i> Digital banking</li>
                    </ul>
                    <a href="#" className="mt-10 block w-full text-center py-4 border border-emerald-500 hover:bg-emerald-900 rounded-2xl font-medium">Learn More</a>
                </div>

                
                <div className="bg-zinc-800 rounded-3xl p-8 card-hover">
                    <div className="h-14 w-14 bg-blue-500/10 rounded-2xl flex items-center justify-center mb-8">
                        <i className="fa-solid fa-hand-holding-dollar text-3xl text-blue-400"></i>
                    </div>
                    <h3 className="text-3xl font-semibold mb-3">Personal Loans</h3>
                    <p className="text-zinc-400 mb-8">Flexible loans for personal needs, home improvement, or emergencies with low rates.</p>
                    <ul className="space-y-3 text-sm">
                        <li className="flex items-center gap-x-3"><i className="fa-solid fa-check text-emerald-400"></i> Competitive rates</li>
                        <li className="flex items-center gap-x-3"><i className="fa-solid fa-check text-emerald-400"></i> Fast approval</li>
                        <li className="flex items-center gap-x-3"><i className="fa-solid fa-check text-emerald-400"></i> Member-first terms</li>
                    </ul>
                    <a href="#" className="mt-10 block w-full text-center py-4 border border-emerald-500 hover:bg-emerald-900 rounded-2xl font-medium">Apply Now</a>
                </div>

                
                <div className="bg-zinc-800 rounded-3xl p-8 card-hover">
                    <div className="h-14 w-14 bg-amber-500/10 rounded-2xl flex items-center justify-center mb-8">
                        <i className="fa-solid fa-home text-3xl text-amber-400"></i>
                    </div>
                    <h3 className="text-3xl font-semibold mb-3">Mortgage &amp; Home Loans</h3>
                    <p className="text-zinc-400 mb-8">Make home ownership possible with our cooperative mortgage solutions.</p>
                    <ul className="space-y-3 text-sm">
                        <li className="flex items-center gap-x-3"><i className="fa-solid fa-check text-emerald-400"></i> Low down payments</li>
                        <li className="flex items-center gap-x-3"><i className="fa-solid fa-check text-emerald-400"></i> Fixed &amp; adjustable rates</li>
                        <li className="flex items-center gap-x-3"><i className="fa-solid fa-check text-emerald-400"></i> Expert guidance</li>
                    </ul>
                    <a href="#" className="mt-10 block w-full text-center py-4 border border-emerald-500 hover:bg-emerald-900 rounded-2xl font-medium">Get Pre-approved</a>
                </div>
            </div>
        </div>
    </section>

    
    <section id="careers" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
                <h2 className="text-5xl heading-font font-bold mb-4">Join Our Growing Team</h2>
                <p className="max-w-md mx-auto text-zinc-600">Help us empower communities through ethical financial services.</p>
            </div>
            <div className="grid md:grid-cols-2 gap-8">
                <div className="border border-zinc-200 rounded-3xl p-10">
                    <div className="uppercase text-xs tracking-widest mb-2 text-emerald-600">Now Hiring</div>
                    <h3 className="text-3xl font-semibold mb-6">Financial Advisor</h3>
                    <p className="text-zinc-600 mb-8">Guide members toward financial wellness. Competitive salary + benefits.</p>
                    <a href="#" className="inline-flex items-center gap-x-3 font-medium text-emerald-600 hover:text-emerald-700">View Details &amp; Apply <span className="text-xl">→</span></a>
                </div>
                <div className="border border-zinc-200 rounded-3xl p-10">
                    <div className="uppercase text-xs tracking-widest mb-2 text-emerald-600">Now Hiring</div>
                    <h3 className="text-3xl font-semibold mb-6">Customer Experience Specialist</h3>
                    <p className="text-zinc-600 mb-8">Be the friendly face of Heritage. Help members every day.</p>
                    <a href="#" className="inline-flex items-center gap-x-3 font-medium text-emerald-600 hover:text-emerald-700">View Details &amp; Apply <span className="text-xl">→</span></a>
                </div>
            </div>
            <div className="text-center mt-12">
                <a href="#" className="text-emerald-600 font-medium hover:underline">See all open positions →</a>
            </div>
        </div>
    </section>
    
    <section id="contact" className="py-24 bg-zinc-900 text-white">
        <div className="max-w-7xl mx-auto px-6">
            <div className="grid md:grid-cols-12 gap-16">
                <div className="md:col-span-5">
                    <h2 className="text-5xl heading-font font-bold mb-8">Get in Touch</h2>
                    <div className="space-y-8">
                        <div>
                            <div className="text-emerald-400 mb-2">📍 Main Office</div>
                            <p>Suite 64 Evergreen Mall,<br />Adjacent American International School,<br />Durumi I, Abuja, FCT.</p>
                        </div>
                        <div>
                            <div className="text-emerald-400 mb-2">📞 Call Us</div>
                            <p className="text-xl font-small">(234) 70-4400-9906</p>
                            <p className="text-xl font-small">(234) 81-1111-2546</p>
                        </div>
                        <div>
                            <div className="text-emerald-400 mb-2">✉️ Email</div>
                            <a href="mailto:info@heritagecoop.org" className="hover:underline">info@heritageco-op.com</a>
                        </div>
                    </div>
                </div>
                <div className="md:col-span-7">
                    <form className="grid grid-cols-1 md:grid-cols-2 gap-6" onSubmit={(e) =>{e.preventDefault(), alert('Thank you! Your message has been received.')}}>
                        <input type="text" placeholder="Your Name" className="bg-zinc-800 border border-zinc-700 focus:border-emerald-500 rounded-2xl px-6 py-4 outline-none" required />
                        <input type="email" placeholder="Email Address" className="bg-zinc-800 border border-zinc-700 focus:border-emerald-500 rounded-2xl px-6 py-4 outline-none" required />
                        <input type="tel" placeholder="Phone Number" className="bg-zinc-800 border border-zinc-700 focus:border-emerald-500 rounded-2xl px-6 py-4 outline-none md:col-span-2" />
                        <textarea placeholder="How can we help you today?" className="bg-zinc-800 border border-zinc-700 focus:border-emerald-500 rounded-3xl px-6 py-4 outline-none md:col-span-2" required></textarea>
                        <button type="submit" className="md:col-span-2 bg-emerald-600 hover:bg-emerald-700 py-4 rounded-2xl font-semibold text-lg transition">Send Message</button>
                    </form>
                </div>
            </div>
        </div>
    </section>

    
    <footer className="bg-black text-white/80 py-20">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-12 gap-y-12">
            <div className="md:col-span-4">
                <div className="flex items-center gap-x-3 mb-6">
                    <div className="w-9 h-9 bg-gradient-to-br from-emerald-600 to-blue-700 rounded-2xl flex items-center justify-center text-white font-bold text-xl">
                      <img src="/heritage.jpg" width="55" height="40" style={{borderRadius:"7px"}} alt="logo" ></img>
                    </div>
                    <span className="text-2xl font-bold heading-font">Heritage Cooperative</span>
                </div>
                <p className="text-sm max-w-xs">Member-owned. Community-driven. Your financial success is our shared mission.</p>
                
                
                <div className="flex gap-x-6 mt-10">
                    <a href="#" className="hover:text-emerald-400 text-2xl"><i className="fa-brands fa-facebook-f"></i></a>
                    <a href="#" className="hover:text-emerald-400 text-2xl"><i className="fa-brands fa-x-twitter"></i></a>
                    <a href="#" className="hover:text-emerald-400 text-2xl"><i className="fa-brands fa-instagram"></i></a>
                    <a href="#" className="hover:text-emerald-400 text-2xl"><i className="fa-brands fa-linkedin-in"></i></a>
                </div>
            </div>
            
            <div className="md:col-span-2">
                <div className="uppercase text-xs tracking-widest mb-6">Company</div>
                <div className="space-y-3 text-sm">
                    <a href="#about" className="block hover:text-white">About Us</a>
                    <a href="#" className="block hover:text-white">Our Story</a>
                    <a href="#" className="block hover:text-white">Leadership</a>
                </div>
            </div>
            
            <div className="md:col-span-2">
                <div className="uppercase text-xs tracking-widest mb-6">Products</div>
                <div className="space-y-3 text-sm">
                    <a href="#products" className="block hover:text-white">Savings</a>
                    <a href="#" className="block hover:text-white">Loans</a>
                    <a href="#" className="block hover:text-white">Mortgages</a>
                </div>
            </div>
            
            <div className="md:col-span-4">
                <div className="uppercase text-xs tracking-widest mb-6">Stay Connected</div>
                <div className="flex">
                    <input type="email" placeholder="Your email" 
                           className="bg-zinc-900 border border-zinc-700 focus:border-white px-6 py-4 rounded-l-3xl text-sm flex-1 outline-none" />
                    <button className="bg-emerald-600 px-8 rounded-r-3xl hover:bg-emerald-500">Subscribe</button>
                </div>
                <p className="text-xs mt-6">© 2026 Heritage Cooperative. All rights reserved.</p>
            </div>
        </div>
    </footer>
    </>
  );
}